module.exports = __webpack_public_path__ + "img/imgWarning.94bcc1a4.svg";